"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Button = _interopRequireDefault(require("../Button"));
var _Spinner = _interopRequireDefault(require("../Spinner"));
var _constant = require("./constant");
var _utils = require("./utils");
var _FlightCard = _interopRequireDefault(require("./FlightCard.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var MainContainer = _styledComponents.default.div.withConfig({
  displayName: "FlightCard__MainContainer",
  componentId: "sc-8ybkre-0"
})(["min-width:300px;max-width:328px;display:flex;border:1px solid ", ";border-radius:", ";"], function (_ref) {
  var _theme$backgroundColo, _theme$backgroundColo2;
  var theme = _ref.theme;
  return (_theme$backgroundColo = (_theme$backgroundColo2 = theme.backgroundColor) === null || _theme$backgroundColo2 === void 0 ? void 0 : _theme$backgroundColo2.gray) !== null && _theme$backgroundColo !== void 0 ? _theme$backgroundColo : theme.backgroundColor.default;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius.medium;
});
var ContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "FlightCard__ContentWrapper",
  componentId: "sc-8ybkre-1"
})(["display:flex;width:100%;flex-direction:column;padding:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.small;
});
var DateContainer = _styledComponents.default.div.withConfig({
  displayName: "FlightCard__DateContainer",
  componentId: "sc-8ybkre-2"
})(["display:flex;flex-direction:column;"]);
var JourneyContainer = _styledComponents.default.div.withConfig({
  displayName: "FlightCard__JourneyContainer",
  componentId: "sc-8ybkre-3"
})(["display:flex;flex-direction:row;align-items:center;justify-content:space-between;margin-top:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.tiny;
});
var BookingDetailsContainer = _styledComponents.default.div.withConfig({
  displayName: "FlightCard__BookingDetailsContainer",
  componentId: "sc-8ybkre-4"
})(["display:flex;flex-direction:row;margin-top:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.tiny;
});
var GuestDetailsConainer = _styledComponents.default.div.withConfig({
  displayName: "FlightCard__GuestDetailsConainer",
  componentId: "sc-8ybkre-5"
})(["display:flex;flex-direction:column;margin-top:", ";margin-bottom:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.micro;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.space.small;
});
var LabelText = _styledComponents.default.div.withConfig({
  displayName: "FlightCard__LabelText",
  componentId: "sc-8ybkre-6"
})(["font-size:", ";line-height:", ";color:", ";font-family:", ";font-weight:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontSize.XSmall;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.lineHeight.small;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.darkSilver;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontFamily.default;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontWeight.bold;
});
var DetailsText = (0, _styledComponents.default)(LabelText).withConfig({
  displayName: "FlightCard__DetailsText",
  componentId: "sc-8ybkre-7"
})(["font-size:", ";line-height:", ";color:", ";"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.fontSize.normal;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.lineHeight.XLarge;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.charcoalGrey;
});
var ToDestLabelText = (0, _styledComponents.default)(DetailsText).withConfig({
  displayName: "FlightCard__ToDestLabelText",
  componentId: "sc-8ybkre-8"
})(["text-align:right;"]);
var BookingDetailsWrapper = _styledComponents.default.div.withConfig({
  displayName: "FlightCard__BookingDetailsWrapper",
  componentId: "sc-8ybkre-9"
})(["display:flex;flex-direction:column;padding-right:", ";"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.space.tiny;
});
var getVisibleNames = function getVisibleNames(names, containerWidth) {
  var computedNames = [];
  var currentWidth = 0;
  for (var i = 0; i < names.length; i++) {
    var nameWidth = (0, _utils.measureTextWidth)(names[i], '16px DM Sans');
    currentWidth += nameWidth;
    if (currentWidth < containerWidth) {
      computedNames.push(names[i]);
    } else {
      // Return visible names and remaining count
      return {
        visibleNames: computedNames,
        remainingCount: names.length - computedNames.length
      };
    }
  }
  return {
    visibleNames: computedNames,
    remainingCount: 0
  };
};
var FlightCard = function FlightCard(props) {
  var accessible = props.accessible,
    theme = props.theme,
    data = props.data,
    translation = props.translation,
    handleSelect = props.handleSelect,
    isLoading = props.isLoading;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);
  var _data$id = data.id,
    id = _data$id === void 0 ? '' : _data$id,
    _data$journeyDate = data.journeyDate,
    journeyDate = _data$journeyDate === void 0 ? '' : _data$journeyDate,
    _data$origin = data.origin,
    origin = _data$origin === void 0 ? '' : _data$origin,
    _data$destination = data.destination,
    destination = _data$destination === void 0 ? '' : _data$destination,
    _data$guestNames = data.guestNames,
    guestNames = _data$guestNames === void 0 ? [] : _data$guestNames,
    _data$flightNumber = data.flightNumber,
    flightNumber = _data$flightNumber === void 0 ? '' : _data$flightNumber,
    _data$bookingNumber = data.bookingNumber,
    bookingNumber = _data$bookingNumber === void 0 ? '' : _data$bookingNumber,
    _data$lastName = data.lastName,
    lastName = _data$lastName === void 0 ? '' : _data$lastName;
  var _getVisibleNames = getVisibleNames(guestNames !== null && guestNames !== void 0 ? guestNames : [], 268),
    visibleNames = _getVisibleNames.visibleNames,
    remainingCount = _getVisibleNames.remainingCount;
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(MainContainer, {
      id: id
    }, /*#__PURE__*/_react.default.createElement(ContentWrapper, null, /*#__PURE__*/_react.default.createElement(DateContainer, null, /*#__PURE__*/_react.default.createElement(LabelText, null, language === null || language === void 0 ? void 0 : language.departs, " ", journeyDate)), /*#__PURE__*/_react.default.createElement(JourneyContainer, null, /*#__PURE__*/_react.default.createElement(DetailsText, null, origin), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: _constant.ICON.FlightReverseIcon,
      fontsize: _constant.STYLE_CONFIG.titleNormal,
      color: _constant.STYLE_CONFIG.charcoalGrey,
      theme: theme,
      accessible: accessible
    }), /*#__PURE__*/_react.default.createElement(ToDestLabelText, null, destination)), /*#__PURE__*/_react.default.createElement(BookingDetailsContainer, null, /*#__PURE__*/_react.default.createElement(BookingDetailsWrapper, null, /*#__PURE__*/_react.default.createElement(LabelText, null, language === null || language === void 0 ? void 0 : language.bookingNo), /*#__PURE__*/_react.default.createElement(DetailsText, null, bookingNumber)), /*#__PURE__*/_react.default.createElement(BookingDetailsWrapper, null, /*#__PURE__*/_react.default.createElement(LabelText, null, language === null || language === void 0 ? void 0 : language.flightNo), /*#__PURE__*/_react.default.createElement(DetailsText, null, flightNumber))), /*#__PURE__*/_react.default.createElement(GuestDetailsConainer, null, /*#__PURE__*/_react.default.createElement(LabelText, null, language === null || language === void 0 ? void 0 : language.guest), /*#__PURE__*/_react.default.createElement(DetailsText, null, visibleNames.join(', '), remainingCount > 0 && ", +".concat(remainingCount))), /*#__PURE__*/_react.default.createElement(_Button.default, {
      buttonType: _constant.STYLE_CONFIG.buttonType,
      backgroundColor: _constant.STYLE_CONFIG.secondary,
      color: _constant.STYLE_CONFIG.default,
      border: _constant.STYLE_CONFIG.secondary,
      hoverBackgroundColor: _constant.STYLE_CONFIG.secondary,
      theme: theme,
      width: _constant.STYLE_CONFIG.buttonSize,
      handleClick: function handleClick() {
        return handleSelect({
          cardId: id,
          origin: origin,
          bookingNumber: bookingNumber,
          lastName: lastName
        });
      },
      fontWeight: _constant.STYLE_CONFIG.bold,
      accessible: accessible,
      customProperties: {
        paddingTop: _constant.STYLE_CONFIG.padding,
        paddingBottom: _constant.STYLE_CONFIG.padding
      },
      disabled: isLoading
    }, !isLoading ? language === null || language === void 0 ? void 0 : language.viewDetials : /*#__PURE__*/_react.default.createElement(_Spinner.default, {
      width: _constant.STYLE_CONFIG.spinnerWidth,
      height: _constant.STYLE_CONFIG.spinnerHeight,
      strokeWidth: _constant.STYLE_CONFIG.spinnerStrokeWidth,
      theme: theme,
      color: _constant.STYLE_CONFIG.secondary
    }))));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
FlightCard.propTypes = _FlightCard.default.PropTypes;
FlightCard.defaultProps = _FlightCard.default.DefaultProps;
var _default = FlightCard;
exports.default = _default;